module.exports = __webpack_public_path__ + "static/img/nosearch@2x.197f2dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/nosearch@2x.png
// module id = sW9X
// module chunks = 18